import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CaracteristiqueValueDto, CaracteristiquesLexiClient, ObjectType, Permissions } from '@lexi-clients/lexi';
import { DxDataGridComponent } from 'devextreme-angular';
import { ArrayStore, DataSource } from 'devextreme/common/data';
import notify from 'devextreme/ui/notify';
import { AuthService } from 'lexi-angular/src/app/settings/auth.service';
import { lastValueFrom } from 'rxjs';
import { NotificationType } from '../references/references';

@Component({
    selector: 'app-gestion-caracteristiques',
    templateUrl: './gestion-caracteristiques.component.html',
    styleUrls: ['./gestion-caracteristiques.component.scss'],
    standalone: false
})
export class GestionCaracteristiquesComponent implements OnInit {
  @ViewChild(DxDataGridComponent) datagrid: DxDataGridComponent;

  private _objectType: ObjectType;
  get objectType() { return this._objectType; }
  @Input() set objectType(value: ObjectType) {
    this._objectType = value;
    if (value && this.objectId != null) {
      this.setDataSource();
    }
  }

  private _objectId: number;
  get objectId() { return this._objectId; }
  @Input() set objectId(value: number) {
    this._objectId = value;
    if (value && this.objectType != null) {
      this.setDataSource();
    }
  }

  private _grouperCaracteristiquesPossibles: boolean = false;
  get grouperCaracteristiquesPossibles() { return this._grouperCaracteristiquesPossibles; }
  @Input() set grouperCaracteristiquesPossibles(value: boolean) {
    if(value != null){
      this._grouperCaracteristiquesPossibles = value;
    }
  }

  canModifierCaracteristiques: boolean = false;
  dataSource: CaracteristiqueValueDto[];
  caracteristiquesDataSource: DataSource;

  constructor(
    private readonly authService: AuthService,
    private readonly caracteristiquesLexiClient: CaracteristiquesLexiClient
  ) { }

  async ngOnInit() {
    this.canModifierCaracteristiques = this.authService.securityUserisGrantedWith(Permissions.canModifierCaracteristiques);
    await this.setDataSource();
  }

  async setDataSource() {
    if(this.objectType) {
      var caracteristiquesList = await lastValueFrom(this.caracteristiquesLexiClient.getCaracteristiquesByObjectType(this.objectType));

      // Cas des caractéristiques partenaire, on affiche les caractéristiques qui n'ont pas le flag IsHidden = true
      if(this.objectType === ObjectType.partenaire){
        caracteristiquesList = caracteristiquesList.filter(c => !c.isHidden);
      }

      this.caracteristiquesDataSource = new DataSource({
        store: new ArrayStore({
          data: caracteristiquesList,
          key: 'id'
        }),
        // grouper les caractéristiques seulement si this.grouper est true
        ...(this.grouperCaracteristiquesPossibles ? { group: 'caracteristiqueGroupe' } : {})
      });

      if(this.objectId) {
        this.dataSource = await lastValueFrom(this.caracteristiquesLexiClient.getAll(this.objectType, this.objectId));
      }
    }
  }

  async onRowInserting(data: CaracteristiqueValueDto) {
    try {
      await lastValueFrom(this.caracteristiquesLexiClient.setValue(data.caracteristique.id, this.objectType, this.objectId, data.valeur));
      notify({closeOnClick: true, message: "Caractéristique créée avec succès" }, NotificationType.Success);
    }
    finally {
      await this.setDataSource();
    }
  }

  async onRowUpdating(e: { oldData: CaracteristiqueValueDto, newData: CaracteristiqueValueDto}) {
    try {
      const data : CaracteristiqueValueDto = {...e.oldData, ...e.newData}
      await lastValueFrom(this.caracteristiquesLexiClient.setValue(data.caracteristique.id, this.objectType, this.objectId, data.valeur)).then(
        () => {notify({closeOnClick: true, message: "Caractéristique modifiée avec succès" }, NotificationType.Success);}
      );
    }
    finally {
      await this.setDataSource();
    }
  }

  async onRowRemoving(data: CaracteristiqueValueDto) {
    try {
      await lastValueFrom(this.caracteristiquesLexiClient.deleteCaracteristiqueValue(data.id));
      notify({closeOnClick: true, message: "Caractéristique supprimée avec succès" }, NotificationType.Success);
    }
    finally {
      await this.setDataSource();
    }
  }

  calculateCellValue(rowData) {
    if (rowData?.caracteristique?.obligatoire == null) {
      return false;
    }
    return rowData?.caracteristique?.obligatoire
  }

  async onKeyDown(e) {
    if (this.canModifierCaracteristiques && e.event.key === "Insert") {
        this.datagrid.instance.addRow();
    }
  }
}
